export default __webpack_public_path__ + "static/media/dana_logo.3150a2d3.svg";